import React from "react"
import { MyUIHelpers } from "@macashipo/mlib"

const MWContent = React.lazy(() => import("./Types/WContent"))
const MUnsupportedMedia = React.lazy(() => import("./Types/UnsupportedMedia"))
const MDOCheckbox = React.lazy(() => import("./Types/DOCheckbox"))
const List = {
  wcontent: MWContent,
  unsupportedmedia: MUnsupportedMedia,
  do_checkbox: MDOCheckbox,
}
const MyUIOne = {
  init() {
    MyUIHelpers.addTypesFromListLazy(List)
  },
}

export default MyUIOne
